import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../components/Logo";
import Footer from "../../components/Footer";
import { ArrowLeft, MessageCircle, Lock, Info, ShieldCheck, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="au-root">
      <header style={S.header}>
        <Link to="/" style={{ textDecoration: "none" }}><Logo size="medium" /></Link>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <Link to="/about" className="au-pill au-pill-ghost au-pill-sm">About</Link>
          <Link to="/" className="au-pill au-pill-glass au-pill-sm">
            <ArrowLeft /> Home
          </Link>
        </div>
      </header>

      <div className="au-container" style={S.container}>
        <div className="au-eyebrow" style={{ marginBottom: 14 }}>Contact Us</div>
        <h1 style={S.h1}>
          Get in <span style={{ color: "var(--au-accent-ink)" }}>Touch</span>
        </h1>
        <p className="au-lead" style={{ marginBottom: 40 }}>We typically respond within 24 hours.</p>

        <div style={S.grid}>
          <ContactCard Icon={MessageCircle} title="General Support" email="support@getkhojo.com" desc="Questions, account help, billing" />
          <ContactCard Icon={Lock} title="Privacy & Data" email="privacy@getkhojo.com" desc="Data requests, privacy concerns" />
          <ContactCard Icon={Info} title="Information" email="info@getkhojo.com" desc="Press, partnerships, general inquiries" />
          <ContactCard Icon={ShieldCheck} title="Security Issues" email="support@getkhojo.com" desc="Vulnerability disclosure, security reports" />
        </div>

        <div style={S.section}>
          <h2 style={S.h2}>Mailing Address</h2>
          <p style={{ ...S.p, display: "flex", alignItems: "flex-start", gap: 10 }}>
            <MapPin style={{ width: 18, height: 18, color: "var(--au-accent-ink)", flex: "none", marginTop: 3 }} />
            <span>getkhojo.com (Aegis Security)<br />India</span>
          </p>
        </div>

      </div>
      <Footer />
    </div>
  );
}

function ContactCard({ Icon, title, email, desc }) {
  return (
    <a href={`mailto:${email}`} className="au-glass au-pad au-lift" style={S.card}>
      <div className="au-badge" style={{ marginBottom: 14 }}><Icon /></div>
      <h3 style={S.cardTitle}>{title}</h3>
      <p style={S.cardDesc}>{desc}</p>
      <div className="au-mono" style={S.cardEmail}>{email} →</div>
    </a>
  );
}

const S = {
  header: { maxWidth: 900, margin: "0 auto", padding: "24px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 },
  container: { maxWidth: 900, padding: "40px 24px 60px" },
  h1: { fontSize: "clamp(2rem, 5vw, 3rem)", margin: "0 0 24px" },
  h2: { fontSize: "clamp(1.2rem, 2.4vw, 1.4rem)", color: "var(--au-text)", margin: "32px 0 14px" },
  p: { fontSize: 14, color: "var(--au-text-2)", lineHeight: 1.8 },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 18, marginBottom: 32 },
  card: { textDecoration: "none", color: "inherit", display: "block" },
  cardTitle: { fontSize: 18, fontWeight: 700, color: "var(--au-text)", margin: "0 0 8px" },
  cardDesc: { fontSize: 13, color: "var(--au-muted)", margin: "0 0 14px", lineHeight: 1.6 },
  cardEmail: { fontSize: 13, color: "var(--au-accent-ink)", fontFamily: "var(--au-font-mono)", fontWeight: 600 },
  section: { marginTop: 32 },
  footer: { textAlign: "center", padding: "40px 0 20px", color: "var(--au-muted)", fontSize: 12, borderTop: "1px solid var(--au-hair)", marginTop: 40 }
};
